
<template>
    <div>
        <template v-if="corp_status == true">
            <div class="global-main bank-account-linking">
                <div class="bank-account-linking-inner">
                    <div class="align-center">
                            <img class="mb-3" src="/images/meezan-logo.jpg" width="250" alt="" /> <br>
                    </div>
                    <h2 class="mb-4">Reset Account MPIN </h2>
                    <form @submit.prevent="changeMpin()">
                        <div class="form-group">
                            <label class="label block-label"> Enter NTN </label>
                            <input type="text" class="form-control" placeholder="Enter NTN"  readonly  maxlength="13" name="Key" v-model="form.Key" :class="{ 'is-invalid': form.errors.has('Key') }" autocomplete="off"/>
                            <has-error :form="form" field="Key"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Enter Mpin Recieved Via SMS </label>
                            <input type="password" class="form-control" placeholder="Enter Mpin Recieved Via SMS" @keypress="isNumber($event)" maxlength="4" name="OldPin" v-model="form.OldPin" :class="{ 'is-invalid': form.errors.has('OldPin') }" autocomplete="off"/>
                            <has-error :form="form" field="OldPin"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Enter New Pin </label>
                            <input type="password" class="form-control" placeholder="Enter New Pin" @keypress="isNumber($event)" maxlength="4" name="NewPin" v-model="form.NewPin" :class="{ 'is-invalid': form.errors.has('NewPin') }" autocomplete="off"/>
                            <has-error :form="form" field="NewPin"></has-error>
                        </div>
                        <div class="form-group mb-0 text-right">
                            <button :disabled="form.busy" class="btn btn-primary proceed active"> Proceed </button>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="corp_status === null">
            <preLoader></preLoader>
        </template>
        <template v-else>
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
  
<script>
    export default {
        data() {
            return {
                corp_status: null,
                form: new Form({
                    Key: '',
                    NewPin: '',
                    OldPin: ''
                }),
            };
        },
        methods: {
            changeMpin(){
                this.$Progress.start();
                this.form.post("/api/changeMpin")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Your MPIN changed successfully.');
                            window.location.href = "/";
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Invalid Mpin');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getCompanyNTN(){
                this.$Progress.start();
                axios.get('/api/getCompanyNTN')
                .then(res => {
                    if(res.status == 200){
                        this.form.Key = res.data.company.ntn;
                        if(res.data.company.corp_account_status == "PINCREATED" || res.data.company.corp_account_status == "RELINK" || res.data.company.corp_account_status == "RESET"){
                            this.corp_status = true;
                        }else{
                           this.corp_status = false;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            }
        },
        mounted() {
            this.getCompanyNTN();
        },

    }
</script>
